import React from 'react'
import {RecipeUpdateProvider} from "../../../context/RecipeUpdateContext";
import RecipeUpdate from "./RecipeUpdate";

const RecipeUpdateContainer = () => {

    return(
        <React.Fragment>
            <RecipeUpdateProvider>
                <RecipeUpdate />
            </RecipeUpdateProvider>
        </React.Fragment>
    )
}
export default RecipeUpdateContainer